/**
 * @generated SignedSource<<a33505a8580b61b35a680ace4bb70c31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiveWidgetEditionEnum = "ASIA" | "HK" | "INT" | "%future added value";
export type homePageQuery$variables = {
  applicationId: string;
  commentHarrySectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  commentQueueName: string;
  dailyPulseTypeUuId: string;
  focusQueueName: string;
  highlightQueueName: string;
  latestExcludeArticleTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  latestExcludeSectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  liveWidgetEditionEnumValue: LiveWidgetEditionEnum;
  morningStudioQueueName: string;
  plusNewsAgendaEndDate: number;
  plusNewsAgendaStartDate: number;
  plusNewsAgendaTypes: ReadonlyArray<string | null | undefined>;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  scmpShortsQueueName: string;
  storyPackageArticlesQueueName: string;
  topStoriesQueueName: string;
};
export type homePageQuery$data = {
  readonly commentQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly morningStudioQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2PickMorningStudioArticle">;
  } | null | undefined;
  readonly storyPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topStories: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"heroArticlesHomeV2Content">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"heroSecondaryArticlesHomeV2QueueItemsEdge" | "topStoriesHomeV2QueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topStoriesEntityIds: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"chinaScienceDiscoveryWidgetQuery" | "commentQueueQuery" | "flexiUnitHomeV2QueueQuery" | "focusArticleHomeFocusArticleQuery" | "hooksPlusWidgetConfigQuery" | "hooksPremiumNativeAdConfigQuery" | "latestContentsHomeV2Query" | "opinionHomeV2QueueQuery" | "plusWidgetHomeV2Query" | "plusWidgetQuery" | "scmpShortsHomeV2Query" | "superSplashHomeV2Query" | "thingsToDoHomeV2Query">;
};
export type homePageQuery = {
  response: homePageQuery$data;
  variables: homePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentHarrySectionIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dailyPulseTypeUuId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "focusQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "highlightQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "latestExcludeArticleTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "latestExcludeSectionIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveWidgetEditionEnumValue"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "morningStudioQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plusNewsAgendaEndDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plusNewsAgendaStartDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plusNewsAgendaTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scmpPlusPaywallTypeIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scmpShortsQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storyPackageArticlesQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topStoriesQueueName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "topStoriesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 18
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "morningStudioQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v8 = {
  "kind": "Variable",
  "name": "scmpPlusPaywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v9 = [
  {
    "kind": "Variable",
    "name": "commentHarrySectionIds",
    "variableName": "commentHarrySectionIds"
  },
  {
    "kind": "Variable",
    "name": "commentQueueName",
    "variableName": "commentQueueName"
  },
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "Variable",
    "name": "focusQueueName",
    "variableName": "focusQueueName"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "edition",
    "variableName": "liveWidgetEditionEnumValue"
  }
],
v12 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v13 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "commentQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v15 = [
  (v14/*: any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
      }
    ],
    "storageKey": null
  }
],
v17 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "storyPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v25/*: any*/),
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v30/*: any*/),
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v29/*: any*/),
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v35 = [
  (v3/*: any*/),
  (v26/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    },
    (v37/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v26/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v44 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v42/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v46/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v41/*: any*/),
    (v47/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v27/*: any*/),
    (v26/*: any*/),
    (v32/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    },
    (v48/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v56 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v57 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v58 = [
  (v24/*: any*/),
  (v55/*: any*/),
  (v23/*: any*/),
  {
    "alias": "size1200x800",
    "args": (v56/*: any*/),
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v25/*: any*/),
    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
  },
  (v57/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v61 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSectionUnion"
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/),
    (v32/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v63 = [
  (v22/*: any*/)
],
v64 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v33/*: any*/),
    (v20/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v41/*: any*/),
    (v47/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v61/*: any*/),
        (v62/*: any*/),
        (v64/*: any*/),
        (v43/*: any*/),
        (v65/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v68 = [
  (v67/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v67/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v42/*: any*/),
        (v44/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/),
    (v46/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v41/*: any*/),
    (v73/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    (v26/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v19/*: any*/),
        (v3/*: any*/),
        (v33/*: any*/),
        (v20/*: any*/),
        (v34/*: any*/),
        (v36/*: any*/),
        (v38/*: any*/),
        (v41/*: any*/),
        (v47/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v26/*: any*/),
        (v22/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "leadingSlides",
  "plural": true,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v83/*: any*/),
    (v26/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    (v72/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v44/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v27/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    (v55/*: any*/),
    (v23/*: any*/),
    (v57/*: any*/)
  ],
  "storageKey": null
},
v92 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v61/*: any*/),
        (v92/*: any*/),
        (v64/*: any*/),
        (v43/*: any*/),
        (v65/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v3/*: any*/),
        (v30/*: any*/),
        (v26/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v95 = {
  "kind": "Variable",
  "name": "paywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v96 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v97 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v98 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v84/*: any*/),
    (v77/*: any*/),
    (v85/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v100 = {
  "alias": "size500x500",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "500x500"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": "style(filter:{\"style\":\"500x500\"})"
},
v101 = [
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v33/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "AUTHOR_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v25/*: any*/),
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
    },
    (v26/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/),
        (v34/*: any*/),
        (v36/*: any*/),
        (v38/*: any*/),
        (v41/*: any*/),
        (v47/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v92/*: any*/),
        (v64/*: any*/),
        (v43/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v83/*: any*/)
  ],
  "storageKey": null
},
v105 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v38/*: any*/),
    (v41/*: any*/),
    (v47/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v107 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v108 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "focusQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v109 = [
  (v105/*: any*/)
],
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v94/*: any*/),
    (v84/*: any*/),
    (v77/*: any*/),
    (v85/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v112 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v44/*: any*/),
            (v43/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
},
v113 = [
  (v22/*: any*/),
  (v3/*: any*/)
],
v114 = {
  "kind": "Literal",
  "name": "first",
  "value": 2
},
v115 = {
  "typeIds": [
    "09ecd76b-0271-467d-be05-c228b9a8ef47"
  ]
},
v116 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v26/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v20/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  (v55/*: any*/),
                  (v23/*: any*/),
                  (v57/*: any*/),
                  (v100/*: any*/)
                ],
                "storageKey": null
              },
              (v60/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v93/*: any*/),
              (v90/*: any*/),
              (v52/*: any*/),
              (v74/*: any*/),
              (v110/*: any*/)
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v117 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v5/*: any*/),
          (v43/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "heroSecondaryArticlesHomeV2QueueItemsEdge"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "topStoriesHomeV2QueueItemsEdge"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "heroArticlesHomeV2Content"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksHomeV2PickMorningStudioArticle",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "homeNativeArticleContentItemContent"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:4)"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "latestExcludeArticleTypes",
            "variableName": "latestExcludeArticleTypes"
          },
          {
            "kind": "Variable",
            "name": "latestExcludeSectionIds",
            "variableName": "latestExcludeSectionIds"
          },
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "latestContentsHomeV2Query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "thingsToDoHomeV2Query"
      },
      {
        "args": (v9/*: any*/),
        "kind": "FragmentSpread",
        "name": "commentQueueQuery"
      },
      {
        "args": (v9/*: any*/),
        "kind": "FragmentSpread",
        "name": "opinionHomeV2QueueQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "scmpShortsQueueName",
            "variableName": "scmpShortsQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "scmpShortsHomeV2Query"
      },
      {
        "args": (v10/*: any*/),
        "kind": "FragmentSpread",
        "name": "focusArticleHomeFocusArticleQuery"
      },
      {
        "args": (v10/*: any*/),
        "kind": "FragmentSpread",
        "name": "flexiUnitHomeV2QueueQuery"
      },
      {
        "args": (v11/*: any*/),
        "kind": "FragmentSpread",
        "name": "superSplashHomeV2Query"
      },
      {
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "dailyPulseTypeUuId",
            "variableName": "dailyPulseTypeUuId"
          },
          {
            "kind": "Variable",
            "name": "highlightQueueName",
            "variableName": "highlightQueueName"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaEndDate",
            "variableName": "plusNewsAgendaEndDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaStartDate",
            "variableName": "plusNewsAgendaStartDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaTypes",
            "variableName": "plusNewsAgendaTypes"
          }
        ],
        "kind": "FragmentSpread",
        "name": "plusWidgetQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "chinaScienceDiscoveryWidgetQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksPlusWidgetConfigQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "plusWidgetHomeV2Query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksPremiumNativeAdConfigQuery"
      },
      {
        "alias": "commentQueue",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "items(first:5)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "topStoriesEntityIds",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "items(first:18)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "items(first:3)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v66/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v45/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v84/*: any*/),
                              (v32/*: any*/),
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v89/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v90/*: any*/),
                          (v54/*: any*/),
                          (v91/*: any*/),
                          (v60/*: any*/),
                          (v21/*: any*/),
                          (v93/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v77/*: any*/),
                              (v94/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:4)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "latestV2Contents",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "articleTypeIds",
                "variableName": "latestExcludeArticleTypes"
              },
              (v95/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "articleExcludeInput"
          },
          {
            "kind": "Literal",
            "name": "articleFilterInput",
            "value": {
              "sponsorTypes": [
                "NONE"
              ]
            }
          },
          {
            "kind": "Literal",
            "name": "contentTypes",
            "value": [
              "ARTICLE",
              "GALLERY",
              "VIDEO"
            ]
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "sectionIds",
                "variableName": "latestExcludeSectionIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "exclude"
          },
          (v14/*: any*/),
          (v96/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v3/*: any*/),
                  (v97/*: any*/),
                  (v20/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v60/*: any*/),
                  (v21/*: any*/),
                  (v93/*: any*/),
                  (v90/*: any*/),
                  (v26/*: any*/),
                  (v74/*: any*/),
                  (v98/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "thingToDoV2Queue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "homepage_service_journalism_hk"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v99/*: any*/),
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v24/*: any*/),
                              (v55/*: any*/),
                              (v23/*: any*/),
                              (v100/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v60/*: any*/),
                          (v21/*: any*/),
                          (v93/*: any*/),
                          (v90/*: any*/),
                          (v74/*: any*/),
                          (v98/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v26/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_service_journalism_hk\"})"
      },
      {
        "alias": "commentSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "93"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v26/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*: any*/),
              (v3/*: any*/),
              (v92/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v101/*: any*/),
                "type": "Author",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v101/*: any*/),
                "type": "Topic",
                "abstractKey": null
              }
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          }
        ],
        "storageKey": "section(filter:{\"entityId\":\"93\"})"
      },
      {
        "alias": "commentQueue",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v102/*: any*/),
                          (v21/*: any*/),
                          (v54/*: any*/),
                          (v60/*: any*/),
                          (v103/*: any*/),
                          (v90/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v104/*: any*/),
                              (v77/*: any*/),
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v87/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "type": "MAIN_IMAGE"
                                    }
                                  }
                                ],
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "alt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v56/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "harryContents",
        "args": [
          {
            "fields": [
              (v95/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "articleExcludeInput"
          },
          {
            "kind": "Literal",
            "name": "contentTypes",
            "value": [
              "GALLERY"
            ]
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "sectionIds",
                "variableName": "commentHarrySectionIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v105/*: any*/),
          (v96/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v97/*: any*/),
                  (v3/*: any*/),
                  (v20/*: any*/),
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      (v55/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": "size660w",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "660w"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"660w\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  (v90/*: any*/),
                  (v26/*: any*/),
                  (v106/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v77/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "opinionQueue",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v107/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v102/*: any*/),
                          (v21/*: any*/),
                          (v54/*: any*/),
                          (v60/*: any*/),
                          (v103/*: any*/),
                          (v90/*: any*/),
                          (v52/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v80/*: any*/),
                              (v104/*: any*/),
                              (v77/*: any*/),
                              (v75/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Article",
                                "kind": "LinkedField",
                                "name": "seriesContainer",
                                "plural": false,
                                "selections": [
                                  (v75/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "scmpShortsV2Queue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "scmpShortsQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v54/*: any*/),
                          (v20/*: any*/),
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "portraitStyle",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "portrait"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"portrait\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v106/*: any*/)
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "focus",
        "args": (v108/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v99/*: any*/),
          {
            "alias": null,
            "args": (v109/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v24/*: any*/),
                              (v55/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": "size1280x720",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                              },
                              {
                                "alias": "size640x360",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape_640_360"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v60/*: any*/),
                          (v21/*: any*/),
                          (v103/*: any*/),
                          (v90/*: any*/),
                          (v20/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v87/*: any*/),
                              (v88/*: any*/)
                            ],
                            "type": "Video",
                            "abstractKey": null
                          },
                          (v110/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v111/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v22/*: any*/),
                                      (v20/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "type": "TERM_LOGO"
                                            }
                                          }
                                        ],
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                  "style": "100x100"
                                                }
                                              }
                                            ],
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v25/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"100x100\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                      }
                                    ],
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v112/*: any*/),
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:1)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "homeV2FlexiUnit",
        "args": (v108/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v99/*: any*/),
          {
            "alias": null,
            "args": (v109/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v54/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v21/*: any*/),
                          (v103/*: any*/),
                          (v90/*: any*/),
                          (v31/*: any*/),
                          (v74/*: any*/),
                          (v110/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v111/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v112/*: any*/),
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:1)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": (v11/*: any*/),
            "kind": "ObjectValue",
            "name": "filter"
          },
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "DESC",
              "field": "UPDATED_DATE"
            }
          }
        ],
        "concreteType": "LiveWidget",
        "kind": "LinkedField",
        "name": "liveWidget",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "style",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "relatedArticles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v26/*: any*/),
              (v33/*: any*/),
              (v20/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v19/*: any*/),
                  (v54/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v62/*: any*/),
                          (v64/*: any*/),
                          (v43/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v69/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": (v68/*: any*/),
                    "storageKey": null
                  },
                  (v71/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v34/*: any*/),
                      (v36/*: any*/),
                      (v38/*: any*/),
                      (v41/*: any*/),
                      (v73/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v78/*: any*/),
                      (v79/*: any*/),
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      (v77/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v32/*: any*/),
                      (v85/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v86/*: any*/)
                    ],
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "storageKey": null
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "dailyPulseQuery",
        "args": [
          {
            "fields": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "typeIds.0",
                    "variableName": "dailyPulseTypeUuId"
                  }
                ],
                "kind": "ListValue",
                "name": "typeIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v105/*: any*/),
          (v96/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v20/*: any*/),
                  (v26/*: any*/),
                  (v48/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v54/*: any*/),
                      (v60/*: any*/),
                      (v19/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v113/*: any*/),
                                "type": "Section",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v113/*: any*/),
                                "type": "VideoSection",
                                "abstractKey": null
                              },
                              (v43/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v90/*: any*/),
                      (v50/*: any*/),
                      (v52/*: any*/),
                      (v51/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v94/*: any*/),
                          (v84/*: any*/),
                          (v77/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "highlightQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "highlightQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v114/*: any*/)
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v54/*: any*/),
                          (v91/*: any*/),
                          (v60/*: any*/),
                          (v21/*: any*/),
                          (v93/*: any*/),
                          (v90/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v45/*: any*/),
                              (v80/*: any*/),
                              (v84/*: any*/),
                              (v77/*: any*/),
                              (v85/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:2)"
          },
          (v26/*: any*/),
          (v99/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v12/*: any*/),
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "endDate",
                    "variableName": "plusNewsAgendaEndDate"
                  },
                  {
                    "kind": "Variable",
                    "name": "startDate",
                    "variableName": "plusNewsAgendaStartDate"
                  }
                ],
                "kind": "ObjectValue",
                "name": "newsAgendaDateRange"
              },
              {
                "kind": "Literal",
                "name": "newsAgendaOptions",
                "value": [
                  "key_event"
                ]
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "plusNewsAgendaTypes"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v14/*: any*/),
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "ASC",
              "field": "NEWS_AGENDA_START_DATE"
            }
          }
        ],
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsAgenda",
                    "kind": "LinkedField",
                    "name": "newsAgenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secondaryDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "time",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newsAgendaOptions",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v22/*: any*/),
                  (v30/*: any*/),
                  (v51/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_settings"
            }
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v68/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
      },
      {
        "alias": "chinaScienceSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "328475"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v22/*: any*/),
          (v3/*: any*/),
          (v37/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"328475\"})"
      },
      {
        "alias": "chinaScienceQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "section_top_328475"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v107/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v59/*: any*/),
                              (v60/*: any*/),
                              (v21/*: any*/),
                              (v66/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v74/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v45/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v75/*: any*/),
                                  (v76/*: any*/),
                                  (v77/*: any*/),
                                  (v78/*: any*/),
                                  (v79/*: any*/),
                                  (v80/*: any*/),
                                  (v81/*: any*/),
                                  (v84/*: any*/),
                                  (v32/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              (v89/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v26/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
      },
      {
        "alias": "dailyPulseArticles",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": (v115/*: any*/)
          },
          (v105/*: any*/),
          (v96/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v116/*: any*/),
        "storageKey": "articles(filter:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
      },
      {
        "alias": "plusArticles",
        "args": [
          {
            "kind": "Literal",
            "name": "exclude",
            "value": (v115/*: any*/)
          },
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "paywallTypeIds": [
                "716f570e-3083-4138-a080-47d3830fafe3"
              ]
            }
          },
          (v114/*: any*/),
          (v96/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v116/*: any*/),
        "storageKey": "articles(exclude:{\"typeIds\":[\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]},filter:{\"paywallTypeIds\":[\"716f570e-3083-4138-a080-47d3830fafe3\"]},first:2,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
      },
      {
        "alias": "advertConfig",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_advert_campaign"
            }
          }
        ],
        "concreteType": "AppConfigs",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v68/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
      },
      {
        "alias": "topStoriesEntityIds",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v117/*: any*/),
            "storageKey": "items(first:18)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v117/*: any*/),
            "storageKey": "items(first:3)"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97f9c4f2866b93b6b1fce2321a4ed764",
    "id": null,
    "metadata": {},
    "name": "homePageQuery",
    "operationKind": "query",
    "text": "query homePageQuery(\n  $applicationId: String!\n  $commentHarrySectionIds: [String]\n  $commentQueueName: String!\n  $dailyPulseTypeUuId: String!\n  $focusQueueName: String!\n  $highlightQueueName: String!\n  $latestExcludeArticleTypes: [String]\n  $latestExcludeSectionIds: [String]\n  $liveWidgetEditionEnumValue: LiveWidgetEditionEnum!\n  $morningStudioQueueName: String!\n  $plusNewsAgendaEndDate: Timestamp!\n  $plusNewsAgendaStartDate: Timestamp!\n  $plusNewsAgendaTypes: [String]!\n  $scmpPlusPaywallTypeIds: [String]\n  $scmpShortsQueueName: String!\n  $storyPackageArticlesQueueName: String!\n  $topStoriesQueueName: String!\n) {\n  topStories: queue(filter: {name: $topStoriesQueueName}) {\n    items(first: 18) {\n      edges {\n        ...heroSecondaryArticlesHomeV2QueueItemsEdge\n        ...topStoriesHomeV2QueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ...heroArticlesHomeV2Content\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  morningStudioQueue: queue(filter: {name: $morningStudioQueueName}) {\n    ...hooksHomeV2PickMorningStudioArticle\n    id\n  }\n  ...latestContentsHomeV2Query_2HMWA1\n  ...thingsToDoHomeV2Query\n  ...commentQueueQuery_pwKp9\n  ...opinionHomeV2QueueQuery_pwKp9\n  ...scmpShortsHomeV2Query_3hK5ms\n  ...focusArticleHomeFocusArticleQuery_4COOKT\n  ...flexiUnitHomeV2QueueQuery_4COOKT\n  ...superSplashHomeV2Query_3oF9in\n  ...plusWidgetQuery_1YyBVf\n  ...chinaScienceDiscoveryWidgetQuery\n  ...hooksPlusWidgetConfigQuery\n  ...plusWidgetHomeV2Query\n  ...hooksPremiumNativeAdConfigQuery\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  topStoriesEntityIds: queue(filter: {name: $topStoriesQueueName}) {\n    items(first: 18) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  storyPackageArticles: queue(filter: {name: $storyPackageArticlesQueueName}) {\n    items(first: 3) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentQueueQuery_pwKp9 on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  harryContents: contents(contentTypes: [GALLERY], first: 1, filter: {sectionIds: $commentHarrySectionIds}, articleExcludeInput: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityId\n        ...harryContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment commentV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_13FlZp\n  ... on Article {\n    authors {\n      entityId\n      id\n    }\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAgendaContentTopic on Topic {\n  newsAgenda {\n    secondaryDescription\n  }\n  description {\n    text\n  }\n  updatedDate\n  name\n  ...hooksNewsAgendaTopic\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_1mXwiv on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size660w: style(filter: {style: \"660w\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1pemU3 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_1tYcF5 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4Kx38 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_byYA5 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_wy32c on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPublishedDateContent on Content {\n  __isContent: __typename\n  publishedDate\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment flexiUnitHomeV2QueueQuery_4COOKT on Query {\n  homeV2FlexiUnit: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ...helpersGetFlexiUnitArticleLabelArticle\n          ...helpersGetFlexiUnitPodcastLabelPodcast\n          ...helpersGetFlexiUnitVideoLabelVideo\n          ...homeV2FlexiUnitContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment harryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3V3HsH\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n        urlAlias\n        image(filter: {type: TERM_LOGO}) {\n          style(filter: {style: \"100x100\"}) {\n            url\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetFlexiUnitArticleLabelArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetFlexiUnitPodcastLabelPodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetFlexiUnitVideoLabelVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment heroArticlesHomeV2Content on Content {\n  __isContent: __typename\n  ...topStoriesItemV2Content\n}\n\nfragment heroSecondaryArticlesHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homeLatestV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3onApn\n}\n\nfragment homeNativeArticleContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2Mm1vQ\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment homeSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  flag\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_4u1L24\n}\n\nfragment homeSuperSplashLargePrimaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_183JXa\n}\n\nfragment homeSuperSplashLargeSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_101wKc\n}\n\nfragment homeSuperSplashLivePrimaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_183JXa\n}\n\nfragment homeThingsToDoV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_iSR0J\n}\n\nfragment homeV2FlexiUnitContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ...hooksContentItemProvidersContent_1Tvcel\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_101wKc on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_13FlZp on Content {\n  __isContent: __typename\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_183JXa on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSubHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1Tvcel on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2FkToZ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_byYA5\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2Mm1vQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3V3HsH on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1mXwiv\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3onApn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_4u1L24 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1tYcF5\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_wy32c\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_iSR0J on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1pemU3\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksHomeV2PickMorningStudioArticle on Queue {\n  items(first: 4) {\n    edges {\n      node {\n        __typename\n        ...homeNativeArticleContentItemContent\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksNewsAgendaTopic on Topic {\n  newsAgenda {\n    startDate\n    endDate\n    time\n    newsAgendaOptions\n  }\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment hooksPlusWidgetConfigQuery on Query {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n  }\n}\n\nfragment hooksPremiumNativeAdConfigQuery on Query {\n  advertConfig: appConfig(filter: {entityId: \"scmp_pwa_advert_campaign\"}) {\n    json\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment itemAgendaItemTopic on Topic {\n  urlAlias\n  newsAgenda {\n    startDate\n  }\n  entityId\n  name\n  ...contentAgendaContentTopic\n  ...hooksNewsAgendaTopic\n}\n\nfragment latestContentsHomeV2Query_2HMWA1 on Query {\n  latestV2Contents: contents(articleExcludeInput: {articleTypeIds: $latestExcludeArticleTypes, paywallTypeIds: $scmpPlusPaywallTypeIds}, articleFilterInput: {sponsorTypes: [NONE]}, contentTypes: [ARTICLE, GALLERY, VIDEO], exclude: {sectionIds: $latestExcludeSectionIds}, first: 5, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...homeLatestV2ContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment opinionHomeV2QueueQuery_pwKp9 on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    id\n  }\n  opinionQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  harryContents: contents(contentTypes: [GALLERY], first: 1, filter: {sectionIds: $commentHarrySectionIds}, articleExcludeInput: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityId\n        ...harryContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusWidgetArticleHomeV2 on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2FkToZ\n}\n\nfragment plusWidgetDailyPulseQuery_3abQBm on Query {\n  dailyPulseQuery: articles(filter: {typeIds: [$dailyPulseTypeUuId]}, first: 1, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        urlAlias\n        ...entityLink\n        ...contentHeadlineContent\n        ...hooksArticleDateUtilsContent\n        ...hooksPlusArticleLinkHandlerArticle\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetHasAccessQuery_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment plusWidgetHighlight on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksContentItemProvidersContent_2Mm1vQ\n  ...plusArticleTypeTitleContent\n}\n\nfragment plusWidgetHighlightsQuery_3iQMXB on Query {\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...plusWidgetHighlight\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment plusWidgetHomeV2Query on Query {\n  dailyPulseArticles: articles(filter: {typeIds: [\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}, first: 1) {\n    edges {\n      node {\n        entityId\n        ...plusWidgetArticleHomeV2\n        id\n      }\n    }\n  }\n  plusArticles: articles(filter: {paywallTypeIds: [\"716f570e-3083-4138-a080-47d3830fafe3\"]}, exclude: {typeIds: [\"09ecd76b-0271-467d-be05-c228b9a8ef47\"]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}, first: 2) {\n    edges {\n      node {\n        entityId\n        ...plusWidgetArticleHomeV2\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetNewsAgendaQuery_3kWRW2 on Query {\n  topics(first: 5, applicationId: $applicationId, filter: {types: $plusNewsAgendaTypes, newsAgendaDateRange: {startDate: $plusNewsAgendaStartDate, endDate: $plusNewsAgendaEndDate}, newsAgendaOptions: [\"key_event\"]}, orderBy: {field: NEWS_AGENDA_START_DATE, direction: ASC}) {\n    edges {\n      node {\n        ...itemAgendaItemTopic\n        ...hooksNewsAgendaTopic\n        newsAgenda {\n          newsAgendaOptions\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetQuery_1YyBVf on Query {\n  ...plusWidgetWithoutAccess_1YyBVf\n  ...plusWidgetHasAccessQuery_1YyBVf\n  ...hooksPlusWidgetConfigQuery\n}\n\nfragment plusWidgetWithoutAccess_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment scmpShortsCard on Video {\n  entityId\n  headline\n  urlAlias\n  youtubeId\n  images {\n    portraitStyle: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n  ...entityLink\n}\n\nfragment scmpShortsHomeV2Query_3hK5ms on Query {\n  scmpShortsV2Queue: queue(filter: {name: $scmpShortsQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            entityId\n            ...scmpShortsCard\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment superSplashHomeV2Query_3oF9in on Query {\n  liveWidget(filter: {edition: $liveWidgetEditionEnumValue}, orderBy: {direction: DESC, field: UPDATED_DATE}) {\n    style\n    ...superSplashLargeHomeV2LiveWidget\n    ...superSplashLiveHomeV2LiveWidget\n    id\n  }\n}\n\nfragment superSplashLargeHomeV2LiveWidget on LiveWidget {\n  label\n  relatedArticles {\n    entityId\n    ...homeSuperSplashLargePrimaryV2ContentItemContent\n    ...homeSuperSplashLargeSecondaryV2ContentItemContent\n    id\n  }\n}\n\nfragment superSplashLiveHomeV2LiveWidget on LiveWidget {\n  label\n  relatedArticles {\n    entityUuid\n    urlAlias\n    ...homeSuperSplashLivePrimaryV2ContentItemContent\n    id\n  }\n}\n\nfragment thingsToDoHomeV2Query on Query {\n  thingToDoV2Queue: queue(filter: {name: \"homepage_service_journalism_hk\"}) {\n    settings\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeThingsToDoV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment topStoriesHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n      ...topStoriesItemV2Content\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemV2Content on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n  ...homeSecondaryV2ContentItemContent\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7c8a7db30895c6e76424d29f3b5b389";

export default node;
